import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=76710760&"
import script from "./MessageBubble.vue?vue&type=script&lang=ts&"
export * from "./MessageBubble.vue?vue&type=script&lang=ts&"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports